<div class="page wpdh-page-wrapper">
  <notification *ngIf="isIEOrEdge" title="Warning" class="-colorAccentYellow">
    You are using an unsupported browser. Please switch to a modern browser such as Chrome, Firefox, or Safari for the intended experience.
  </notification>

  <div *ngIf="hasContent"
  [ngClass]="meta?.type === 'Platforms'
  ? '-platforms-wrapper' : meta?.type === 'Enterprise'
  ? '-enterprise-wrapper' : meta?.type === 'Smb'
  ? '-smb-wrapper' : meta?.type === 'Payfac'
  ? '-payfac-wrapper' : meta?.type === 'Financial Institution'
  ? '-financial-institution-wrapper' : meta?.type === 'Independent Sales Org'
  ? '-independent-sales-organization-wrapper' : meta?.type === 'Independent Software Vendor'
  ? '-independent-software-vendor-wrapper' : meta.type === 'customerexperience'
  ? '-customerexperience-wrapper' : meta.type === 'allproduct'
  ? '-result-wrapper': meta.type === 'marketplaces'
  ? '-marketplaces-wrapper' :''">
    <div class="-spec-page-wrapper" *ngIf="meta.template === globals.TEMPLATE_TYPES.REDOC">
      <app-redoc
        [body]="body"
        [categories]="categories"
        [pageRoute]="pageRoute"
        [routeRedocSubscription]="routeRedocSubscription">
      </app-redoc>
      <app-spec-footer></app-spec-footer>
    </div>
    <app-product
      *ngIf="meta.template === globals.TEMPLATE_TYPES.PRODUCT"
      [body]="body"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-product>
    <apis
      *ngIf="meta.template === globals.TEMPLATE_TYPES.APIS_PAGE"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </apis>
    <div class="-doc-page-wrapper" *ngIf="meta.template === globals.TEMPLATE_TYPES.PUBLIC
    || meta.template === globals.TEMPLATE_TYPES.CONTACT_PAGE
    || meta.template === globals.TEMPLATE_TYPES.PRODUCT_LANDING
    || meta.template === globals.TEMPLATE_TYPES.CATEGORY
    || meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW
    || meta.template === globals.TEMPLATE_TYPES.DOC_PAGE
    || meta.template === globals.TEMPLATE_TYPES.PROD_DOC_PAGE
    || meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE
    || meta.template === globals.TEMPLATE_TYPES.CONTACT_SALES">
      <left-nav
        class="-left-nav-container"
        *ngIf="meta.template !== globals.TEMPLATE_TYPES.PUBLIC && meta.template !== globals.TEMPLATE_TYPES.CONTACT_PAGE"
        [meta]="meta"
        [isSecNav]="isSecNav"
        [isSidebarPresent]="isSidebarPresent"
        [sidebarShow]="sidebarShow"
        [ngClass]="{'-left-nav-doc-container': (meta.template === 'doc-page' || meta.template === 'prod-doc-page' || meta.template === 'article' || meta.template === 'contact-sales') , '-hide-sec-nav': !isSecNav, '-overlay-sec-nav': sidebarShow, '-hide-left-nav': (meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE)}"
        (sidebarEvent)="sidebarShowHandler($event)"></left-nav>
        <div class="-content" [ngClass]="{'-product-content': (meta.template === 'doc-page'
        || meta.template === 'prod-doc-page'
        || meta.template === 'article'
        || meta.template === 'contact-sales'),
        '-product-doc-content': meta.template === 'prod-doc-page',
        '-contact-content': meta.template === 'contact-page',
        '-product-landing-content': meta.template === 'product-landing',
        '-category-content': meta.template === 'category',
        '-contact-form-content': meta.type === 'form',
        '-hide-sec-nav': !isSecNav }" #content>
        <div class="-docpage-content-container" [ngClass]="{'-public-content-container': (meta.template === 'public' && isDocIndex),
        '-add-secondary-nav': (meta.template === (globals.TEMPLATE_TYPES.PRODUCT_LANDING || globals.TEMPLATE_TYPES.CATEGORY) && isSecNav),
        '-product-landing-container': (meta.template === globals.TEMPLATE_TYPES.PRODUCT_LANDING),
        '-category-container': (meta.template === globals.TEMPLATE_TYPES.CATEGORY),
        '-prod-doc-container': (meta.template === globals.TEMPLATE_TYPES.PROD_DOC_PAGE),
        '-article-doc-container': (meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE),
        '-contact-page-container': (meta.template === globals.TEMPLATE_TYPES.CONTACT_PAGE),
        '-contact-page-form': (meta.type === 'form'),
        '-contact-sales-form': contactSales}">
          <app-contact-page
            *ngIf="meta.template === globals.TEMPLATE_TYPES.CONTACT_PAGE && !contactSales"
            [body]="body"
            [meta]="meta"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </app-contact-page>
          <app-public
            *ngIf="meta.template === globals.TEMPLATE_TYPES.PUBLIC"
            [body]="body"
            [meta]="meta"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </app-public>
          <app-product-landing
            *ngIf="meta.template === globals.TEMPLATE_TYPES.PRODUCT_LANDING && !contactSales "
            [body]="body"
            [meta]="meta"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </app-product-landing>
          <app-category
            *ngIf="meta.template === globals.TEMPLATE_TYPES.CATEGORY && !contactSales "
            [body]="body"
            [meta]="meta"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </app-category>
          <app-api-overview
            *ngIf="meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW && !contactSales"
            [body]="body"
            [meta]="meta"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </app-api-overview>
          <app-doc
            *ngIf="meta.template === globals.TEMPLATE_TYPES.DOC_PAGE&& !contactSales "
            [body]="body"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </app-doc>
          <article-doc
            *ngIf="meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE && !contactSales "
            [body]="body"
            [categories]="categories"
            [pageRoute]="pageRoute">
          </article-doc>
          <app-prod-doc
          *ngIf="meta.template === globals.TEMPLATE_TYPES.PROD_DOC_PAGE && !contactSales "
          [body]="body"
          [categories]="categories"
          [pageRoute]="pageRoute">
        </app-prod-doc>
          <app-contact-sales
          *ngIf="contactSales"
          [body]="body"
          [meta]="meta"
          [categories]="categories"
          [pageRoute]="pageRoute"
          ></app-contact-sales>
        </div>
      </div>
    </div>
    <app-basic
      *ngIf="meta.template !== globals.TEMPLATE_TYPES.PUBLIC
      && meta.template !== globals.TEMPLATE_TYPES.PRODUCT
      && meta.template !== globals.TEMPLATE_TYPES.REDOC
      && meta.template !== globals.TEMPLATE_TYPES.APIS_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.PRODUCT_LANDING
      && meta.template !== globals.TEMPLATE_TYPES.CATEGORY
      && meta.template !== globals.TEMPLATE_TYPES.API_OVERVIEW
      && meta.template !== globals.TEMPLATE_TYPES.DOC_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.PROD_DOC_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.ARTICLE_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.HOMEPAGE
      && meta.template !== globals.TEMPLATE_TYPES.LEARNINGPAGE
      && meta.template !== globals.TEMPLATE_TYPES.CONTACT_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.CONTACT_SALES
      && meta.template !== globals.TEMPLATE_TYPES.HOME
      && meta.template !== globals.TEMPLATE_TYPES.SEARCH_RESULT
      && meta.template !== globals.TEMPLATE_TYPES.BUSINESS_TYPE"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-basic>
    <app-homepage
      *ngIf="meta.template === globals.TEMPLATE_TYPES.HOMEPAGE"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-homepage>
    <app-home
      *ngIf="meta.template === globals.TEMPLATE_TYPES.HOME"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-home>
    <app-business-type
      *ngIf="meta.template === globals.TEMPLATE_TYPES.BUSINESS_TYPE"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-business-type>
    <app-learning-page
      *ngIf="meta.template === globals.TEMPLATE_TYPES.LEARNINGPAGE"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-learning-page>
    <app-search-results
      *ngIf="meta.template === globals.TEMPLATE_TYPES.SEARCH_RESULT"
      [body]="body"
      [meta]="meta"
      [categories]="categories"
      [pageRoute]="pageRoute">
    </app-search-results>
  </div>

  <div *ngIf="!hasContent">Content failed to load!</div>

  <div *ngIf="getapikeyInfoModal">
    <modal
      [visible]="true"
      (visibleChange)="closeInfoModal()"
      [secondaryModal]="true"
      [title]="'Not logged in !'">
      <div>
      <p class="-fontSmall -colorAccentGrey -description-padding">
          You must login to access this feature
      </p>
      <div>
          <wpbutton type="submit" to="/account/login">Login</wpbutton>
          <wpbutton type="submit" to="/account/register">Create a free account</wpbutton>
      </div>
      </div>
    </modal>
  </div>
</div>
